<template>
  <Modal ref="modalRef" :title="$t('front.language')">
    <SetLanguage />

    <template #footer>
      <Button @click="close">{{ $t('global.close') }}</Button>
    </template>
  </Modal>
</template>
<script setup>
import Modal from "@/js/Components/Modal/Modal.vue";
import {ref} from "vue";
import Button from "@/js/Elements/Button.vue";
import SetLanguage from "@/js/Components/SetLanguage/SetLanguage.vue";

const modalRef = ref();

function close() {
  modalRef.value.close();
}
</script>